import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

import { useRecoilState } from "recoil";
import { AdminMenus } from "../../../components/recoil/atoms/Menus";

import Paging from "../../components/includes/Paging";
import Header from "../../components/includes/Header";
import FaqSearch from "../../components/boards/FaqSearch";
import FaqSearchResult from "../../components/boards/FaqSearchResult";
import FaqTypes from "../../components/boards/FaqTypes";

import {ChangeDateStringOnlyDate,LoginAfterCheckLogin} from "../../../components/common/Common";

/* css */
import "../../../css/admin_layout.css";
import "../../../css/admin_board.css";
import "../../../css/admin.css";

const FaqList = () => {
  LoginAfterCheckLogin(0);  //로그인 상태 점검

  const [varAdminMenus,setAdminMenus] = useRecoilState(AdminMenus);

  //컬럼기본
  let columnList = [
    {Header:'번호',accessor:'board_num',width:50},
    {Header:'분류',accessor:'vf_name',width:70},
    {Header:'제목',accessor:'board_title',width:300},
    {Header:'열람수',accessor:'board_hits',width:90},
    {Header:'등록일자',accessor:'board_rdate',width:120},
    {Header:'고유번호',accessor:'board_idx',width:20},
  ]
  const [varColumnLists,setColumnLists] = useState([]);
    
  //검색 정보 저장 변수
  const [varSearchData, setSearchData] = useState({
    searchType:0,
    searchOption:"all",
    searchString:''
  });

  //게시글 목록 저장 변수
  const [varFaqLists,setFaqLists] = useState([]);
  //페이지 조절 변수
  const [varTotalCount, setTotalCount] = useState(0);
  const [varPageSize] = useState(10);
  const [varPageNum, setPageNum] = useState(1);

  //게시판 정보 전체 가져오기
  const ReadFaqLists = async() => {
    var sendData = {mode:2,currentPage:varPageNum,pageSize:varPageSize,searchData:varSearchData};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/_get_board_list`, sendData).then((res) => {
      console.log(res.data);
      const datas = res.data;
      if (datas.retvalue === 1) {
        setFaqTypeList(datas.faq_types);
        setTotalCount(datas.totalcount);
        let newArray = [];
        const pmax = datas.totalcount - (varPageNum - 1) * varPageSize;
        if(datas.results?.length > 0) {
          const dataArray = datas.results;
          for(var i=0; i < dataArray.length; i++) {
            const lineObj = dataArray[i];
            var newData = {};
            newData['board_num'] = pmax - i;
            newData['vf_name'] = lineObj.vf_name;
            newData['board_title'] = lineObj.board_title;
            newData['board_rdate'] = ChangeDateStringOnlyDate(lineObj.board_rdate);
            newData['board_hits'] = lineObj.board_hits;
            newData['board_idx'] = lineObj.board_idx;
            newArray.push(newData);
          }
        }
        setFaqLists(newArray);
      } else {
        setTotalCount(0);
        setFaqLists([]);
        alert(datas.message);
      }
    });
  }

  useEffect(() => {
    setAdminMenus({type:'ENVIRONMENT',item:'FAQ'});
    console.log(varAdminMenus);
    setColumnLists(columnList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    ReadFaqLists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varPageNum,varSearchData]);

  //FAQ분류관리
  const [varFaqTypeList,setFaqTypeList] = useState([]);
  const [varShowFaqTypes,setShowFaqTypes] = useState(false);
  const onManageFaqTypeHandler = (e) => {
    setShowFaqTypes(true);
  }

  return (
    <div id="admin_contents" className="adm_contents">
      <Header varTitle={'FAQ'} varDirection={'설정'}/>
      <div className="admin-content">
        <FaqSearch varSearchData={varSearchData} setSearchData={setSearchData} setPageNum={setPageNum} varFaqTypeList={varFaqTypeList} onManageFaqTypeHandler={onManageFaqTypeHandler}/>
        {varFaqLists?.length===0?
          <div className="main-box" style={{marginTop:"30px"}}>
            <div className="btn-right">
              <div><label htmlFor="tcount">검색건수</label>&nbsp;<span id="tcount">{varTotalCount}</span>&nbsp;건</div>&nbsp;&nbsp;&nbsp;
              <Link to={`/Admin/FaqDetail/0`} className="btn-danger">신규등록</Link>
            </div>
            <div className="scroll-table"></div>
          </div>
        :
          <FaqSearchResult varColumnLists={varColumnLists} 
          varFaqLists={varFaqLists}  varTotalCount={varTotalCount} ReadFaqLists={ReadFaqLists}/>}
        <Paging totalCount={varTotalCount} pageSize={varPageSize} curPage={varPageNum} setPage={setPageNum} />
      </div>
      {!varShowFaqTypes?null:<FaqTypes varShowFaqTypes={varShowFaqTypes} varFaqTypeList={varFaqTypeList} 
            setFaqTypeList={setFaqTypeList} setShowFaqTypes={setShowFaqTypes}/>}
    </div>
  );
}
export default FaqList